import React from 'react';
import TimelineBlock from './TimelineBlock';
import TimelineStepsField from './TimelineStepsField';
import { TIMELINE_LAYOUT_OPTIONS } from './timelineLayout';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckBorderField } from '../../../puck/fields/puckBorderField';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckVerticalAlignField } from '../../../puck/fields/puckVerticalAlignField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import { puckShadowField } from '../../../puck/fields/puckShadowField';
import { SHADOW_LABEL } from '../../../../shared/boxes/shadowStyles';
import {
  themedBlockProps, themedBlockResolveData, themedBlockResolveFields,
} from '../../../puck/themedBlocks';
import { styleDefaults } from '../../../../shared/theme/styleSchema';
import { TIMELINE_STYLE_SCHEMA } from './timelineStyleSchema';
import { puckThemeStyleField } from '../../../puck/fields/ThemeStyleSelectField';

const timelineBlockConfig = {
  label: 'Frise',
  // Démo au drop : l'utilisateur voit le rendu et remplace par ses données.
  defaultProps: {
    items: [
      {
        title: 'Cadrage',
        date: 'Semaine 1',
        description: 'Ateliers de cadrage et définition du périmètre.',
        icon: 'IconFlag',
      },
      {
        title: 'Conception',
        date: 'Semaines 2 à 4',
        description: 'Maquettes, itérations et validation des parcours.',
        icon: 'IconPencil',
      },
      {
        title: 'Livraison',
        date: 'Semaine 6',
        description: 'Mise en ligne et transfert de compétences.',
        icon: 'IconRocket',
      },
    ],
    ...styleDefaults(TIMELINE_STYLE_SCHEMA),
    alignHorizontal: 'center',
    alignVertical: 'center',
  },
  // Date, titre et description des étapes s'éditent UNIQUEMENT sur le canvas
  // (règle InfoCard) : la liste ne porte que les attributs.
  fields: withThemedFieldValues('timeline', {
    _section1: puckSectionField('Contenu'),
    items: {
      type: 'custom',
      label: 'Étapes',
      render: (props) => <TimelineStepsField {...props} />,
    },

    _sectionGallery: puckStyleGallerySectionField('Frise'),
    themeStyleId: puckThemeStyleField('timeline'),

    _section2: puckSectionField('Style'),
    layout: {
      type: 'select',
      label: 'Disposition',
      /* Options trop longues pour la demi-largeur. */
      layout: 'stacked',
      options: TIMELINE_LAYOUT_OPTIONS,
    },
    // Pas de transparent : une frise au trait invisible n'a pas de sens.
    color: puckColorField('Couleur de la frise'),
    bulletSize: puckPxSpacingField('Diamètre des puces'),
    border: puckBorderField('Bordures'),
    backgroundColor: puckColorField('Couleur de fond', { allowTransparent: true }),
    shadow: puckShadowField(SHADOW_LABEL),

    _sectionText: puckSectionField('Typographie'),
    textStyles: puckTextRolesField([{ key: 'date', label: 'Date' }, { key: 'title', label: 'Titre' }, { key: 'description', label: 'Description' }]),

    _section3: puckSectionField('Affichage'),
    alignHorizontal: puckHorizontalAlignField(),
    alignVertical: puckVerticalAlignField(),
  }),
  // Suit son style du thème, s'il en a un, retouches du thème comprises
  // (lien vivant, cf. puck/themedBlocks).
  resolveData: themedBlockResolveData('timeline'),
  resolveFields: themedBlockResolveFields('timeline'),
  render: (props) => <TimelineBlock {...themedBlockProps('timeline', props, props.puck?.metadata)} />,
};

export default timelineBlockConfig;
